<template>
<ProgressCircular v-if="loading"/>
  <form v-else novalidate :disabled="disabled" @submit.prevent="submit()">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200" flat color="transparent">
          <v-card-title class="mb-10">
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              :link="'page-kiosk-devices'"
              :title="getTitle ? `Редактировать ${getTitle}` : `Добавить киоск`"
            />
          </v-card-title>
          <v-card-text>
            <PageContent height="85">
              <v-container>
                <!-- Kiosk Name -->
                <v-row>
                  <v-col cols="12">
                    <span>Имя *</span>
                    <v-text-field
                    id="kioskName"
                      outlined
                      :autofocus="!fields.kioskName"
                      :error-messages="validationErrors.kioskName"
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.kioskName"
                    />
                  </v-col>
                </v-row>
                <!-- wifiSsid -->
                <v-row>
                  <v-col cols="12">
                    <span>wifi ssid</span>
                    <v-text-field
                      outlined
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.wifiSsid"
                    />
                  </v-col>
                </v-row>
                <!-- apiKey -->
                <v-row>
                  <v-col cols="12">
                    <span>Api key *</span>
                    <v-text-field
                    id="apiKey"
                      readonly
                      outlined
                      class="v-text-field--mono-font"
                      :error-messages="validationErrors.apiKey"
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.apiKey"
                    />
                    <v-btn
                      x-small
                      outlined
                      color="primary"
                      :loading="loading"
                      :disabled="disabled"
                      @click="generateKeys()"
                    >
                      Сформировать api key
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- transportWidgetUrl -->
                <v-row>
                  <v-col cols="12">
                    <span>Transport url</span>
                    <v-text-field
                      outlined
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.transportWidgetUrl"
                    />
                  </v-col>
                </v-row>
                <!-- is Active -->
                <v-row>
                  <v-col cols="12">
                    <v-switch
                      outlined
                      label="Активен"
                      :error-messages="validationErrors.isActive"
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.isActive"
                    />
                  </v-col>
                </v-row>
                <!-- isExternalMonitorActive -->
                <v-row>
                  <v-col cols="12">
                    <v-switch
                      outlined
                      label="Активен внешний монитор"
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.isExternalMonitorActive"
                    />
                  </v-col>
                </v-row>
                <!-- is Online -->
                <v-row>
                  <v-col cols="12">
                    <v-icon
                      v-text="'mdi-checkbox-marked-circle'"
                      :color="data.isOnline ? 'success' : 'grey'"
                    />
                    <span>
                    {{ data.isOnline ? 'Онлайн' : 'Оффлайн' }}
                  </span>
                  </v-col>
                </v-row>
                <!-- Location -->
                <v-row>
                  <v-col cols="12">
                    <span>Расположение</span>
                    <LocationAutocomplete
                      :address="fields.location"
                      :loading="loading || disabled"
                      @set-location="setLocation"
                      @update-location-part="updateLocation"
                    />
                  </v-col>
                </v-row>
                <!-- Serial Number -->
                <v-row>
                  <v-col cols="6">
                    <span>Серийный номер *</span>
                    <v-text-field
                    id="serialNumber"
                      outlined
                      :error-messages="validationErrors.serialNumber"
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.serialNumber"
                    />
                  </v-col>
                </v-row>
                <!-- StreamLogin -->
                <v-row>
                  <v-col cols="12">
                    <span>Логин трансляции *</span>
                    <v-text-field
                      readonly
                      outlined
                      id="streamLogin"
                      class="v-text-field--mono-font"
                      :error-messages="validationErrors.streamLogin"
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.streamLogin"
                    />
                    <v-btn
                      x-small
                      outlined
                      color="primary"
                      :loading="loading"
                      :disabled="disabled"
                      @click="
                      generateKeys(
                        'streamLogin',
                        'string',
                        10,
                        12,
                        'login',
                        'abcdefghijklmnopqrstuvwxyz-_'
                      )
                    "
                    >
                      Сформировать логин трансляции
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- streamPassword -->
                <v-row>
                  <v-col cols="12">
                    <span>Пароль трансляции *</span>
                    <v-text-field
                      readonly
                      outlined
                      id="streamPassword"
                      class="v-text-field--mono-font"
                      :error-messages="validationErrors.streamPassword"
                      :loading="loading"
                      :disabled="disabled"
                      v-model="fields.streamPassword"
                    />
                    <v-btn
                      x-small
                      outlined
                      color="primary"
                      :loading="loading"
                      :disabled="disabled"
                      @click="
                      generateKeys(
                        'streamPassword',
                        'string',
                        6,
                        8,
                        '',
                        'abcdefghijklmnopqrstuvwxyz123456789-_'
                      )
                    "
                    >
                      Сформировать пароль трансляции
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- transportWidgetUrl -->
                <v-row v-if="!isNew">
                  <v-col cols="12">
                    <span>Stream url</span>
                    <v-text-field
                      outlined
                      readonly
                      class="v-text-field--mono-font"
                      :loading="loading"
                      :disabled="disabled"
                      :value="fields.streamUrl"
                    />
                  </v-col>
                </v-row>
                <!-- Kiosk Type -->
                <v-row>
                  <v-col cols="6">
                    <span>Тип *</span>
                    <v-select
                      outlined
                      id="type"
                      :loading="loading"
                      :disabled="disabled"
                      :items="$options.kioskTypes"
                      :error-messages="validationErrors.type"
                      :item-text="'text'"
                      :item-value="'value'"
                      v-model="fields.type"
                    />
                  </v-col>
                </v-row>
                <!-- Kiosk banner type -->
                <FormKioskBannerType
                  requiredField
                  :banner-type="fields.bannerType"
                  :loading-data="disabled"
                  :loading="loading"
                  :content="getBannerContent('bannerType')"
                  :title="'Тип рекламного баннера'"
                  :errorBannerType="validationErrors.bannerType"
                  @banner-type-change="fields.bannerType = $event"
                  @update-content="updateContent('bannerType', $event)"
                />
                <FormKioskBannerType
                  requiredField
                  :banner-type="fields.externalBannerType"
                  :loading-data="disabled"
                  :loading="loading"
                  :content="getBannerContent('externalBannerType')"
                  :title="'Активировать дополнительный монитор'"
                  :errorBannerType="validationErrors.externalBannerType"
                  @banner-type-change="fields.externalBannerType = $event"
                  @update-content="updateContent('externalBannerType', $event)"
                />
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          :isNew="isNew"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :is-submit-disabled="disabled"
          :isLocales="false"
          :language="language"
          :translations="fields.translations"
          :entity-id="data.id"
          :entity-type="'kioskDevice'"
          @delete="$emit('delete-kiosk')"
          @cancel="$router.push({ name: 'page-kiosk-devices' })"
        >
          <template #body>
            <v-col cols="12">
              <CityPicker title="Город" :loading="loading || disabled" v-model="fields.cityId" />
            </v-col>
            <v-col cols="12">
              <PlacePicker title="Место" :loading="loading || disabled" v-model="fields.placeId" />
            </v-col>
          </template>
        </ManageSidePanel>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import kioskTypes from '@/configs/kioskTypes'
import kioskBunnerType from '@/configs/kioskBannerType'
import { defaultDateFormat } from '@/configs/date.js'
import tabs from '@/configs/tabs.js'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'

import Geolocation from '@/utils/types/Geolocation.js'

import generateApiKey from 'generate-api-key'
import validationRules from './validation-rules'

import FormAbstract from '@/components/abstract/form'
import LocationAutocomplete from '@/components/location-autocomplete'
import ManageSidePanel from '@/components/manage-side-panel'
import CityPicker from '@/components/city-picker'
import PlacePicker from '@/components/place-picker/PlacePicker.vue'
import FormHeader from '@/components/form-header'
import FormKioskBannerType from './form-kiosk-device-banner-type'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'

export default {
  name: 'FormKioskDevice',
  tabs,
  defaultDateFormat,
  kioskTypes,
  kioskBunnerType,
  mediaTypesByKeys: mediaTypesByKeys(),
  validationRules,
  extends: FormAbstract,
  components: {
    PageContent,
    ManageSidePanel,
    LocationAutocomplete,
    CityPicker,
    PlacePicker,
    FormHeader,
    FormKioskBannerType,
    ProgressCircular
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: true
    },
    language: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: {
        kioskName: null,
        wifiSsid: null,
        apiKey: null,
        isActive: false,
        location: new Geolocation(),
        serialNumber: null,
        placeId: null,
        type: null,
        cityId: null,
        transportWidgetUrl: null,
        bannerType: null,
        imageBannerId: null,
        videoBannerId: null,
        urlBanner: null,
        externalBannerType: null,
        externalBannerUrlBanner: null,
        externalBannerVideoBannerId: null,
        externalBannerImageBannerId: null,
        isExternalMonitorActive: false,
        translations: { ru: { isEnabled: true } },
        streamLogin: null,
        streamPassword: null,
        streamUrl: null
      }
    }
  },
  computed: {
    getTitle () {
      if (this.data) {
        return this.data?.kioskName || ''
      }
      return null
    }
  },
  watch: {
    data (data) {
      this.populate(data)
      this.fields.cityId = data?.city?.id || null
      this.fields.placeId = data?.place?.id || null
      this.setFields('bannerType', data?.bannerType || null)
      this.setFields('externalBannerType', data?.externalBannerType || null)
      this.setFields('imageBannerId', data?.imageBanner?.id || null)
      this.setFields('videoBannerId', data?.videoBanner?.id || null)
      this.setFields('urlBanner', data?.urlBanner || null)
      this.setFields(
        'externalBannerImageBannerId',
        data?.externalBannerImageBanner?.id || null
      )
      this.setFields(
        'externalBannerVideoBannerId',
        data?.externalBannerVideoBanner?.id || null
      )
      this.setFields('externalBannerUrlBanner', data?.externalBannerUrlBanner || null)
    }
  },
  methods: {
    getBannerContent (bannerType) {
      switch (bannerType) {
        case 'bannerType':
          return {
            imageBannerId: this.fields?.imageBannerId || null,
            videoBannerId: this.fields?.videoBannerId || null,
            urlBanner: this.fields?.urlBanner || null
          }
        case 'externalBannerType':
          return {
            imageBannerId: this.fields?.externalBannerImageBannerId || null,
            videoBannerId: this.fields?.externalBannerVideoBannerId || null,
            urlBanner: this.fields?.externalBannerUrlBanner || null
          }
        default:
          return null
      }
    },
    setFields (field, value) {
      // !Vue set!
      this.$set(this.fields, field, value)
    },
    setLocation (location) {
      this.fields.location = location
    },
    updateLocation ({ value, fieldName }) {
      this.fields.location[fieldName] = value
    },
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      this.prepareBanners()
      const payload = {
        ...this.composeFormData(this.fields)
      }
      delete payload.streamUrl
      this.$emit('submit', payload)
    },
    prepareBanners () {
      if (this.fields.bannerType === 'NONE') {
        this.fields.imageBannerId = null
        this.fields.videoBannerId = null
        this.fields.urlBanner = null
      }
      if (this.fields.externalBannerType === 'NONE') {
        this.fields.externalBannerImageBannerId = null
        this.fields.externalBannerVideoBannerId = null
        this.fields.externalBannerUrlBanner = null
      }
    },
    generateKeys (...args) {
      const [
        fieldName = 'apiKey',
        methodGenerate = 'string',
        min = 10,
        max = 16,
        prefix = 'kiosk',
        pool = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~+/'
      ] = args
      this.fields[fieldName] = generateApiKey({
        method: methodGenerate,
        min,
        max,
        prefix,
        pool
      })
    },
    changeBanner (field, value) {
      this.fields[field] = value
      switch (field) {
        case 'imageBannerId':
          this.fields.videoBannerId = null
          this.fields.urlBanner = null
          break
        case 'videoBannerId':
          this.fields.imageBannerId = null
          this.fields.urlBanner = null
          break
        case 'urlBanner':
          this.fields.imageBannerId = null
          this.fields.videoBannerId = null
          break
        default:
          break
      }
    },
    updateContent (bannerType, value) {
      switch (bannerType) {
        case 'externalBannerType':
          this.fields.externalBannerVideoBannerId = value?.videoBannerId || null
          this.fields.externalBannerImageBannerId = value?.imageBannerId || null
          this.fields.externalBannerUrlBanner = value?.urlBanner || null
          break
        case 'bannerType':
          this.fields.videoBannerId = value?.videoBannerId || null
          this.fields.imageBannerId = value?.imageBannerId || null
          this.fields.urlBanner = value?.urlBanner || null
          break
        default:
          break
      }
    }
  }
}
</script>
<style>
div.v-text-field--mono-font
  div.v-input__control
  div.v-input__slot
  div.v-text-field__slot
  input {
  font-family: monospace;
}
</style>
